import PropTypes from 'prop-types';
import React, { Component, memo } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import StaticContainer from 'react-static-container';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import uniqWith from 'lodash/uniqWith';
import isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { detectisEdge, detectisIE } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Image from 'yoda-core-components/lib/components/Image/Image';
import {
    selectPreferences,
    selectIsMobilePDPImageZoomed,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import BVSummary from 'yoda-site-components/lib/components/BVSummary/BVSummary';
import CouponExclusionBadge from 'yoda-site-components/lib/components/CouponExclusionBadge/CouponExclusionBadge';
import Quantity from 'yoda-site-components/lib/components/Quantity/Quantity';
import ProductTitle from 'yoda-site-components/lib/components/ProductTitle/ProductTitle';
import ProductPricing from 'yoda-site-components/lib/components/ProductPricing/ProductPricing';
import productPricingSelector, {
    productLotSelector,
    bopisIncentiveProductEligibilitySelector,
} from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import selectRecPageType from 'yoda-site-components/lib/selectors/PDPPLASelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import ProductOptions from 'yoda-site-components/lib/components/ProductOptions/ProductOptions';

import FreestarAd from 'yoda-site-components/lib/components/FreestarAd/FreestarAdConnectLazy';
import Messages from 'yoda-site-components/lib/components/Messages';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import SpecialOffers from 'yoda-site-components/lib/components/SpecialOffers/SpecialOffers';
import { isCookieDisabled } from 'yoda-site-components/lib/helpers/Utils/parseOnetrust';
import {
    OPTANON_COOKIE,
    TRACKING,
} from 'yoda-site-components/lib/helpers/Utils/parseOnetrustConfig.config';
import { selectedProductSkus } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { bopisIncentive } from 'yoda-site-components/lib/common/ProductConstants';
import { templateTypes } from 'yoda-site-components/lib/selectors/productDetails/selectProductType.config';
import { getCriteoData } from 'yoda-site-components/lib/actions/CriteoAction';
import BNPLBannerLazy from 'yoda-site-components/lib/components/BNPLBanner/BNPLBannerLazy';
import RevieveModal from 'yoda-site-components/lib/components/Revieve/RevieveModal';
import QuickScreenLazy from 'yoda-account-components/lib/components/SYFQuickScreen/QuickScreenLazy';
import { isQuickScreenEligible } from 'yoda-account-components/lib/helpers/Utils/Utils';
import IconArrowRight from '../../../../assets/png/Arrow_down.svg';
import { ADD_TO_CART_MESSAGES_ID } from '../../../../components/AddToCart/AddToCart.config';
import * as styles from '../PDP.css';
import Metadata from '../../../../components/Metadata/Metadata';
import AddToCart from '../../../../components/AddToCart/AddToCart';
import PDPBreadcrumbs from '../../../../components/PDPBreadcrumbs/PDPBreadcrumbs';
import BrandLink from '../../../../components/BrandLink/BrandLink';
import ProductModelNumber from '../../../../components/ProductModelNumber/ProductModelNumber';
import ProductImage from '../../../../components/ProductImage/ProductImage';
import Canonicalize from '../../../../components/Canonicalize/Canonicalize';
import ProductInfoMobile from '../../../../components/ProductInfo/ProductInfoMobile';
import ProductInfoDesktop from '../../../../components/ProductInfo/ProductInfoDesktop';
import MerchantMarketing from '../../../../components/MerchantMarketing/MerchantMarketingLazy';
import ProductCollection from '../../../../components/ProductCollection/ProductCollection';
import ShopTheLook from '../../../../components/ShopTheLook/ShopTheLookLazy';
import ShopTheSet from '../../../../components/ShopTheSet/ShopTheSetLazy';
import MixandMatch from '../../../../components/MixandMatch/MixandMatchLazy';
import DescriptionAndShipping from '../../../../components/DescriptionAndShipping/DescriptionAndShipping';
import IrisS1ClientPromoBanner from '../../../../components/IrisS1PromoBanner/IrisS1ClientPromoBanner';
import KeyFeatures from '../../../../components/KeyFeatures/KeyFeatures';
import VTO from '../../../../components/VirtualTryOn/VirtualTryOn';
import VTOToggle from '../../../../components/VirtualTryOn/VirtualTryOnToggle';
import { PLA_REC_PAGE_TYPE, HOW_TO_STYLE_IT } from '../../../../helpers/ProductConstants';
import getVirtualTryOnData from '../../../../selectors/VirtualTryOnSelector';
import { getMOQDropdownValue } from '../../../../selectors/QuantityDropDownSelector';
import BelowTheFold from '../../../../components/BelowTheFold/BelowTheFold';
import ProductOptionsErrorBanner from '../../../../components/ProductOptionsErrorBanner/ProductOptionsErrorBanner';
import BVUserGeneratedContent from '../../../../components/BVUserGeneratedContent/BVUserGeneratedContentLazy';
import {
    SKINNEY_BANNER_CATID_EXCLUSION_LIST,
    SKINNEY_BANNER_EMPTY_DIV_HEIGHT,
} from '../../../../components/SkinnyBanner/Config';
import { PLCC_BANNER_EMPTY_DIV_HEIGHT } from '../../../../components/PLCCBanner/Config';
import {
    getMappedCategoryId,
    getPLCCMessage,
    getPLCCMessageByPrice,
    showPLCCBanner,
    getSpecificThreshold,
} from '../../../../helpers/BannerHelper';
import SkinnyClientBanner from '../../../../components/SkinnyBanner/SkinnyClientBanner';
import PLCCBanner from '../../../../components/PLCCBanner/PLCCBanner';
import HaircareImage from '../../../../assets/png/haircareImage.png';
import SkincareImge from '../../../../assets/png/skincareImge.png';

const cx = classNames.bind(styles);
export class Regular extends Component {
    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        addToCartMessages: PropTypes.oneOfType([PropTypes.array]),
        analytics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        bopisIncentiveProductEligibility: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        inventory: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isBeauty: PropTypes.bool,
        isCollection: PropTypes.bool,
        isNative: PropTypes.bool,
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pdpProductType: PropTypes.object,
        ppId: PropTypes.string,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productCollectionItems: PropTypes.oneOfType([PropTypes.object]),
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        quantityDropDownValue: PropTypes.number,
        query: PropTypes.oneOfType([PropTypes.object]),
        recPageType: PropTypes.string,
        selectedLotPrice: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedProductLot: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        updatedSKUId: PropTypes.string,
        slot1: PropTypes.element,
        slot2: PropTypes.element,
        slot4: PropTypes.element,
        slot5: PropTypes.element,
        virtualTryOn: PropTypes.oneOfType([PropTypes.object]),
        isQuickScreenEligible: PropTypes.bool,
        isMobilePDPImageZoomed: PropTypes.bool,
    };

    static defaultProps = {
        addToCartMessages: [],
        analytics: {},
        bopisIncentiveProductEligibility: {},
        deviceType: {},
        featureFlags: {},
        inventory: {},
        isBeauty: false,
        isCollection: false,
        isNative: false,
        location: {},
        pdpProductType: {},
        ppId: '',
        preferences: {},
        productCollectionItems: {},
        productDetails: {},
        quantityDropDownValue: 25,
        query: {},
        recPageType: '',
        selectedLotPrice: {},
        selectedProductLot: [],
        updatedSKUId: '',
        slot1: null,
        slot2: null,
        slot4: null,
        slot5: null,
        virtualTryOn: {},
        isQuickScreenEligible: false,
        isMobilePDPImageZoomed: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            errorBannerMessage: null,
            firstLoad: true,
            isOrientationLandscape: false,
            isOrientationLandscapeForZoom: false,
            isQSBannerEligible: false,
            isShopTheLook: {},
            jumpLinkImage: null,
            isSkinnyBannerHasData: false,
            qsBannerCallbackData: {},
            homeDivisionLotLevel: '',
            styliticsCheck: 0,
        };
    }

    componentDidMount() {
        const {
            deviceType: { isDesktop = false },
            isNative,
            featureFlags,
            preferences,
        } = this.props;
        if (!isDesktop) {
            this.handleOrientationChange();
            window.addEventListener('resize', () => this.handleOrientationChange());
        }
        this.setState({
            isQSBannerEligible: isQuickScreenEligible({ isNative, featureFlags, preferences }),
        });
    }

    // eslint-disable-next-line camelcase
    /* istanbul ignore next */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { featureFlags, isNative, preferences, selectedProductLot } = nextProps;
        if (
            nextProps?.isQuickScreenEligible &&
            this.props?.isQuickScreenEligible !== nextProps?.isQuickScreenEligible
        ) {
            this.setState({
                isQSBannerEligible: isQuickScreenEligible({ isNative, featureFlags, preferences }),
            });
        }
        this.setState({
            homeDivisionLotLevel: get(selectedProductLot, '[0].organization.division', ''),
        });
    }

    componentDidUpdate() {
        const {
            actions = {},
            featureFlags: { enableCriteo = false } = {},
            pdpProductType: { templateType },
            ppId,
            query: { selectedSKUId = '', storeIds },
            updatedSKUId = '',
            selectedProductLot,
        } = this.props;
        const { firstLoad } = this.state;
        if (!__SERVER__ && enableCriteo && templateType !== 'bundle') {
            const mappedPrice = this.getMappedPrice();
            /* istanbul ignore next */
            if (mappedPrice && firstLoad && selectedProductLot?.length === 1) {
                actions.getCriteoData({
                    availability: this.getInventory(),
                    item: updatedSKUId || selectedSKUId,
                    pageType: 'PDP',
                    parentItem: ppId,
                    price: mappedPrice,
                    params: {
                        storeIds,
                    },
                });
                this.setState({
                    firstLoad: false,
                });
                this.state.firstLoad = false;
            }
        }
    }

    componentWillUnmount() {
        const {
            deviceType: { isDesktop = false },
        } = this.props;
        if (!isDesktop) {
            window.removeEventListener('resize', () => this.handleOrientationChange());
        }
        if (this.styliticsTimeout) {
            clearTimeout(this.styliticsTimeout);
        }
    }

    setIsSkinnyBannerHasData = (data) => {
        this.setState({
            isSkinnyBannerHasData: data,
        });
    };

    /* istanbul ignore next */
    setQSBannerCallbackData = (data) => {
        this.setState({
            qsBannerCallbackData: data,
        });
    };

    /**
     *
     * @param {*} productPrice selected produce price from input
     * @param {*} bnplMinPrice from config bnpl min price
     * @param {*} bnplMaxPrice from config bnpl max price
     * input value productPrice have ',' & '$' than replace with empty string & same as bnplMinPrice & bnplMaxPrice
     * compare productPrice greater than bnplMinPrice & lesser than bnplMaxPrice
     * @returns true
     */
    /* istanbul ignore next */
    bnplProductPriceEligible = (productPrice, bnplMinPrice, bnplMaxPrice) => {
        const prodPrice = productPrice?.replace(/\$|,/g, '');
        const bnplStartPrice = bnplMinPrice?.replace(/\$|,/g, '');
        const bnplEndPrice = bnplMaxPrice?.replace(/\$|,/g, '');
        return (
            parseFloat(prodPrice) >= parseFloat(bnplStartPrice) &&
            parseFloat(prodPrice) <= parseFloat(bnplEndPrice)
        );
    };

    /* istanbul ignore next */
    getMappedPrice = () => {
        const {
            pricingDetails,
            productDetails: { hybridIndicator = false },
        } = this.props;
        let mappedprice = '';
        const fpacPrice = pricingDetails?.fpac && pricingDetails?.fpac[0]?.amount?.min;
        const defaultPrice = pricingDetails?.defaults || pricingDetails?.original;
        if (hybridIndicator && pricingDetails?.defaults && pricingDetails?.original) {
            mappedprice = fpacPrice || pricingDetails?.defaults;
        } else {
            mappedprice = fpacPrice || defaultPrice;
        }
        // adding this as price returning as number in few cases
        if (mappedprice) {
            mappedprice = mappedprice?.toString();
            // this is for criteo if price has range no fpac price available then consider min value from range
            mappedprice = mappedprice?.includes('-') ? mappedprice?.split('-')?.[0] : mappedprice;
            mappedprice = mappedprice?.trim()?.replace('$', '')?.replace(',', '');
        }
        return mappedprice;
    };

    /* istanbul ignore next */
    getInventory = () => {
        const {
            inventory,
            query: { selectedSKUId },
            updatedSKUId,
        } = this.props;
        let inventoryStatus = 0;
        const availableinventory = inventory[0]?.inventory;
        if (!availableinventory) return inventoryStatus;
        const updatedSelectedId = updatedSKUId || selectedSKUId;
        if (updatedSelectedId) {
            const selectedSkuInv = availableinventory?.find(
                (item) => item.id === updatedSelectedId
            );
            inventoryStatus = selectedSkuInv?.atp;
        } else {
            inventoryStatus = availableinventory?.some((item) => item?.atp);
        }
        return inventoryStatus ? 1 : 0;
    };

    renderPricingStack = (ppId, selectedLotPrice, deviceType, isBNPLeligible) => {
        const {
            featureFlags: { displayCouponExclusions = true },
            pricingDetails = {},
        } = this.props;
        return (
            <section>
                <ErrorBoundary>
                    <div>
                        <ProductPricing
                            pricingDetails={pricingDetails}
                            ppId={ppId}
                            couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                            deviceType={deviceType}
                            fpacPriceIndicator={selectedLotPrice.fpacDisplayIndicator}
                            isBNPLeligible={isBNPLeligible}
                        />
                        {displayCouponExclusions ? (
                            <CouponExclusionBadge
                                couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                            />
                        ) : null}
                    </div>
                </ErrorBoundary>

                <ErrorBoundary>
                    <SpecialOffers
                        fromMiniPDP={false}
                        deviceType={deviceType}
                        fpacPriceIndicator={selectedLotPrice.fpacDisplayIndicator}
                        isBNPLeligible={isBNPLeligible}
                        couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                    />
                </ErrorBoundary>
            </section>
        );
    };

    /* istanbul ignore next */
    outfitsData = (data) => {
        this.setState({
            isShopTheLook: data,
        });
    };

    /* istanbul ignore next */
    jumpLinkImage = (data) => {
        this.setState({
            jumpLinkImage: data,
        });
    };

    /* istanbul ignore next */
    handleOrientationChange = () => {
        const {
            deviceType: { isMobile, isDesktop },
        } = this.props;
        const orientation = window && window?.matchMedia('(orientation: landscape)').matches;
        if (isMobile) {
            this.setState({
                isOrientationLandscape: orientation,
            });
        }
        if (!isDesktop) {
            this.setState({
                isOrientationLandscapeForZoom: orientation,
            });
        }
    };

    /* istanbul ignore next */
    getTop = (elem, deviceType = {}) => {
        const stickyHeaderHeight = 90;

        let result = elem.offsetTop;

        result = elem.offsetHeight !== 0 ? result - stickyHeaderHeight : result;

        return result;
    };

    /* istanbul ignore next */
    shopTheSetAvailable = () => {
        const shopTheSetDOM =
            document && document.getElementsByClassName('stylitics-ms-widget-root');
        return shopTheSetDOM && shopTheSetDOM.length > 0;
    };

    /* istanbul ignore next */
    styliticsWidgetAvailable = () => {
        const { homeDivisionLotLevel } = this.state;
        if (typeof window === 'undefined') return false;

        const hasElementContent = (elements) =>
            elements?.length > 0 && elements[0]?.children?.length > 0;
        const hasContainerContent = (element) => element?.children?.length > 0;

        const mixAndMatchGrid = document.getElementsByClassName('stylitics-grid-base');
        const mixAndMatchContainer = document.getElementById('stylitics-widget-container');
        const shopTheLookDOM = [
            ...document.getElementsByClassName('stylitics-beauty-widget-base'),
            ...document.getElementsByClassName('stylitics-dimension-collage-base'),
        ];

        const hasShopTheSetContent =
            this.shopTheSetAvailable() &&
            hasElementContent(document.getElementsByClassName('stylitics-ms-widget-root'));
        const hasMixAndMatchContent =
            hasElementContent(mixAndMatchGrid) || hasContainerContent(mixAndMatchContainer);
        const hasShopTheLookContent =
            !isEmpty(homeDivisionLotLevel) && hasElementContent(shopTheLookDOM);

        // State fallback only when DOM elements exist
        const hasDOMElements =
            this.shopTheSetAvailable() ||
            mixAndMatchGrid.length > 0 ||
            !!mixAndMatchContainer ||
            shopTheLookDOM.length > 0;
        const hasStateContent =
            hasDOMElements &&
            (!isEmpty(this.state.isShopTheLook) || !isEmpty(this.state.jumpLinkImage));
        // Delayed DOM check for Stylitics elements after scripts load
        if (
            !hasDOMElements &&
            !hasShopTheLookContent &&
            !hasMixAndMatchContent &&
            !hasShopTheSetContent &&
            !this.styliticsTimeout &&
            this.state.styliticsCheck < 5
        ) {
            this.styliticsTimeout = setTimeout(() => {
                this.styliticsTimeout = null;
                this.setState({ styliticsCheck: this.state.styliticsCheck + 1 });
            }, 1000);
        }

        const result =
            hasShopTheSetContent ||
            hasMixAndMatchContent ||
            hasShopTheLookContent ||
            (hasShopTheSetContent && hasStateContent) ||
            (hasShopTheSetContent && hasDOMElements); // Return true if DOM elements exist, even without content

        return result;
    };

    /* istanbul ignore next */
    scrollToShopTheLookOnJumplinkClick = () => {
        const shopTheSetSection = document && document.getElementById('widget-title-STS');
        const shopTheLookSection = this.shopTheSetAvailable()
            ? shopTheSetSection
            : document && document.getElementById('widget-title');
        if (shopTheLookSection) {
            const top = this.getTop(shopTheLookSection, this.props.deviceType) + 70;
            /* istanbul ignore else */
            if (!detectisIE() && !detectisEdge()) {
                setTimeout(() => {
                    window.scrollTo({
                        top,
                        behavior: 'smooth',
                        block: 'start',
                    });
                }, 100);
            } else {
                shopTheLookSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }
    };

    render() {
        const {
            productDetails,
            featureFlags,
            deviceType,
            ppId,
            query,
            isCollection,
            slot1,
            slot2,
            slot4,
            slot5,
            isBeauty,
            selectedProductLot,
            selectedLotPrice,
            // productPrice,
            analytics,
            bopisIncentiveProductEligibility,
            pdpProductType,
            isNative,
            preferences,
            virtualTryOn: { data = {} },
            recPageType,
            quantityDropDownValue,
            isMobilePDPImageZoomed,
        } = this.props;

        const isMTMOrVdata =
            pdpProductType.templateType === 'mtm' || pdpProductType.templateType === 'vdata';

        const { brand = {} } = productDetails;
        const [{ id: productId } = {}] = selectedProductLot;
        const {
            enableFreestarAdComponent = true,
            disableOldSkuBelow,
            enableBVUserGeneratedContent = false,
        } = featureFlags;
        const isTrackingCookieActive = !isCookieDisabled(TRACKING, OPTANON_COOKIE);
        const productIcons = get(selectedProductLot[0], 'productIcons', []);
        /* istanbul ignore next */
        const valuesList = uniqWith(
            flatten(productIcons.map((item) => item.valueIcons)),
            (prevItem, nextItem) => prevItem.value === nextItem.value
        );
        const { isMobile: isMobileView, isDesktop: isDesktopView } = deviceType;
        const {
            homeDivisionLotLevel,
            isSkinnyBannerHasData,
            isOrientationLandscape,
            isQSBannerEligible,
            qsBannerCallbackData,
        } = this.state;
        const qsEligible = get(qsBannerCallbackData, 'qsEligible');
        /* istanbul ignore next */
        const displayQSBanner = qsEligible !== undefined ? qsEligible : isQSBannerEligible;
        const rowClasses = disableOldSkuBelow
            ? [cx('row'), dt(['bg-white', 'm-0', 'px-0', 'pb-0'])].join(' ')
            : [dt(['bg-white', 'm-0', 'pt-4', 'px-0', 'pb-0']), cx('row')].join(' ');
        const productImageSectionClasses = [
            dt([
                'bg-white',
                'w-full',
                'm-0',
                'pb-10',
                'sm:!flex',
                'smOnly:flex-wrap',
                isMobileView ? `${'pt-0'}` : 'pt-2',
            ]),
            cx('row'),
        ].join(' ');
        const homeDivision = get(selectedProductLot, '[0].organization.division', '');
        const isShopTheSetEligible = get(productDetails, 'shopTheSet', false);
        const mixAndMatchDivisions = get(preferences, 'mixandMatch.mnmEligibleDivisions', '');
        const displayBopisIncentive = () => {
            const lotChannelOffering = get(selectedProductLot, '[0].channelOffering', '');
            /* istanbul ignore next */
            const isBopisIncentiveAvailable =
                bopisIncentiveProductEligibility.currentLotEligible &&
                productDetails.bopisEligibility &&
                lotChannelOffering !== 'OnlineOnly';
            return (
                /* istanbul ignore next */
                isBopisIncentiveAvailable ? (
                    <div className={cx('bopis-incentive-message')}>
                        <p
                            className={`${dt([
                                'text-urgency-border font-open-sans-semibold-italic text-normal my-4',
                            ])} ${cx({ 'px-2': isMobileView && disableOldSkuBelow })}`}
                        >
                            {bopisIncentive.eligibilityMessage}
                        </p>
                    </div>
                ) : null
            );
        };
        const displayBreadCrumb = () => (
            <ErrorBoundary>
                <PDPBreadcrumbs ppId={ppId} query={query} />
            </ErrorBoundary>
        );

        const mixAndMatchBlock = () => {
            return (
                <ErrorBoundary>
                    <div>
                        {!isEmpty(homeDivision) &&
                        mixAndMatchDivisions.includes(homeDivision) &&
                        !isMTMOrVdata &&
                        !detectisIE() ? (
                            <MixandMatch
                                productDetails={productDetails}
                                outfitsData={this.outfitsData}
                                jumpLink={this.jumpLinkImage}
                            />
                        ) : null}
                    </div>
                </ErrorBoundary>
            );
        };

        const renderTitleSection = () => (
            <div
                className={cx('sm12', 'md12', 'lg12', 'xl12', 'productTitleContainer')}
                data-automation-id="product-title"
            >
                <ErrorBoundary>
                    <ProductTitle
                        dataAutomationId="product-title"
                        className={dt(['lg:!text-lg', 'smMd:!text-base'])}
                        title={productDetails.name}
                        primary
                        primaryProductDisplay
                        arrivalDisplayTitle={get(productDetails, 'arrival', '')}
                    />
                </ErrorBoundary>
                {brand.brandPageUrl && get(featureFlags, 'enableBrandLink', true) ? (
                    <section>
                        <ErrorBoundary>
                            <BrandLink productDetails={productDetails} />
                        </ErrorBoundary>
                    </section>
                ) : null}
                <section>
                    <div className={cx('productDetailsInfo')}>
                        <ErrorBoundary>
                            <ProductModelNumber />
                        </ErrorBoundary>
                    </div>
                </section>
                {disableOldSkuBelow ? (
                    <ErrorBoundary>
                        <div
                            className={cx('col10', 'noPad', 'bvSummary-wrapper')}
                            data-automation-id="bazaar-voice"
                        >
                            {get(featureFlags, 'bazaarVoice', true) && (
                                <BVSummary productDetails={productDetails} primaryProductDisplay />
                            )}
                        </div>
                        {productId ? (
                            <span id="productLotNumber" className={cx('productId')}>
                                {productId}
                            </span>
                        ) : null}
                    </ErrorBoundary>
                ) : null}
            </div>
        );
        let pdpDivision = '';
        const breadcrumbs = get(productDetails, 'breadCrumbInfo.breadcrumbs', []);
        /* istanbul ignore next */
        if (breadcrumbs.length) {
            pdpDivision = get(breadcrumbs, '[1].breadCrumbLabel', '');
        }
        const templateType = get(this.props.pdpProductType, 'templateType', '');
        const isBNPLeligible = get(selectedProductLot, '[0].buyNowPayLaterEligible', false);

        const freestarAdClasses = [
            cx(
                !get(featureFlags, 'enableFreestarAlignment', true) && 'bv-ad',
                !get(featureFlags, 'enableFreestarAlignment', true) && 'col3'
            ),
            dt([
                get(featureFlags, 'enableFreestarAlignment', true) && 'inline-block',
                get(featureFlags, 'enableFreestarAlignment', true) && 'px-2',
            ]),
        ].join(' ');
        const {
            enableHttpsCanonical = true,
            displayAds = true,
            enableS1IrisPromoBanner = false,
            enableSSRS1IrisPromoBanner = false,
            productImageResizeOnScroll = false,
            disableBnpl = false,
            enableSkinnyBanner = false,
            enablePLCCBanner = false,
            enablePLCCBannerPriceBasedOffer = true,
            enableRevieveModulePDP = true,
            enableZoomOnProductImage = false,
        } = featureFlags;

        let renderS1Banner;
        if (enableS1IrisPromoBanner) {
            renderS1Banner = (
                <IrisS1ClientPromoBanner
                    productDetails={productDetails}
                    ppId={ppId}
                    tmplType=""
                    topPromotionalBanner
                />
            );
        }
        const {
            skinnyBannerConfig: {
                emptyDivHeight = SKINNEY_BANNER_EMPTY_DIV_HEIGHT,
                exclusionCatIds = SKINNEY_BANNER_CATID_EXCLUSION_LIST,
            } = {},
            plccBannerConfig: { emptyPlccDivHeight = PLCC_BANNER_EMPTY_DIV_HEIGHT } = {},
        } = preferences;
        const getMappedPriceVar = this.getMappedPrice();
        const mappedcatid =
            (enableSkinnyBanner || enablePLCCBanner) && getMappedCategoryId(productDetails);
        const plccMessage =
            enablePLCCBanner &&
            !isEmpty(getMappedPriceVar) &&
            (enablePLCCBannerPriceBasedOffer
                ? getPLCCMessageByPrice(mappedcatid, getMappedPriceVar, preferences)
                : getPLCCMessage(mappedcatid, getMappedPriceVar, preferences));
        const specificThreshold =
            enablePLCCBanner &&
            !isEmpty(getMappedPriceVar) &&
            getSpecificThreshold(mappedcatid, preferences);
        let isDisplayPLCCBanner = false;
        /* istanbul ignore next */
        if (enablePLCCBanner && !isEmpty(plccMessage)) {
            isDisplayPLCCBanner = showPLCCBanner(
                plccMessage,
                specificThreshold,
                getMappedPriceVar,
                preferences
            );
        }
        const isDisplaySkinnyBanner =
            !enableS1IrisPromoBanner &&
            enableSkinnyBanner &&
            !exclusionCatIds?.includes(mappedcatid);
        if (isDisplaySkinnyBanner) {
            renderS1Banner = (
                <SkinnyClientBanner
                    emptyDivHeight={emptyDivHeight}
                    topPromotionalBanner
                    checkBannerData={this.setIsSkinnyBannerHasData}
                />
            );
        }
        const bnplProdPriceEligible = this.bnplProductPriceEligible(
            getMappedPriceVar,
            preferences?.bnplConfig?.bnplMinPrice,
            preferences?.bnplConfig?.bnplMaxPrice
        );
        const revieveAdvisor = preferences?.revieveAdvisor?.revieveAdvisorDetails;
        const selectedProduct = get(selectedProductLot, '[0].organization.subdivision', '');
        const filteredAdvisors = revieveAdvisor?.filter(
            (advisor) => advisor?.subdivision === selectedProduct
        );
        if (!__SERVER__ && filteredAdvisors?.length > 0) {
            sessionStorage.setItem('productSubdivision', selectedProduct);
        } else if (!__SERVER__) {
            sessionStorage.removeItem('productSubdivision');
        }
        const isJumpLinkAvailable =
            this.styliticsWidgetAvailable() && !(filteredAdvisors?.length > 0);
        const revieveModulePDP = () => (
            <div
                className={dt([
                    'flex',
                    'items-center',
                    'h-[82px]',
                    'bg-[#E7EFF7]',
                    'rounded-lg',
                    'lg:w-[396px]',
                    'flex-end',
                    'gap-[25px]',
                ])}
                data-automation-id="at-revieve"
            >
                <div
                    className={dt([
                        'left-[13px]',
                        'w-[46px]',
                        'relative',
                        'h-[82px]',
                        'rotate-[-6deg]',
                        'flex-shrink-0',
                    ])}
                    data-automation-id="at-revieve-icon"
                >
                    <Image
                        src={selectedProduct === '960' ? SkincareImge : HaircareImage}
                        imgClass={dt([
                            '!w-full',
                            '!h-full',
                            'border',
                            'border-solid',
                            'border-[#4D4D4D]',
                            'rounded-lg',
                            'shadow-[rgba(32,_32,_32,_0.25)_-2.043px_2.997px_5.993px_0px]',
                        ])}
                        alt="revieve_banner"
                        imageRatio={0}
                        automationId="at-revieve-icon-img"
                    />
                </div>
                <div
                    className={dt(['pt-[17px]', 'lg:pr-[63px]', 'pb-[18px]', 'w-full'])}
                    data-automation-id="at-revieveModule-text"
                >
                    <div
                        className={dt([
                            'text-base',
                            'font-semibold',
                            'underline-solid',
                            'leading-6',
                            'font-semibold',
                            'underline',
                            'text-left',
                        ])}
                        data-automation-id="at-revieveModule-label"
                    >
                        {filteredAdvisors[0]?.label}
                    </div>
                    <div
                        className={dt(['leading-6', 'font-normal', 'text-left'])}
                        data-automation-id="at-revieveModule-discription"
                    >
                        {filteredAdvisors[0]?.discription}
                    </div>
                </div>
            </div>
        );
        return (
            <>
                <ErrorBoundary>
                    {featureFlags.performURLProfanity ? (
                        <Canonicalize
                            productDetails={productDetails}
                            location={this.props.location}
                        />
                    ) : null}
                </ErrorBoundary>
                <ErrorBoundary>
                    <Metadata
                        productDetails={productDetails}
                        preferences={preferences}
                        lotPriceInventory={selectedLotPrice}
                        location={this.props.location}
                        httpsCanonical={enableHttpsCanonical}
                        deviceType={deviceType}
                    />
                </ErrorBoundary>
                <section
                    className={`${cx('pdp-container')} ${dt([
                        'px-6',
                        'bg-white',
                        !isEmpty(renderS1Banner) && isSkinnyBannerHasData
                            ? 'smOnly:pt-0'
                            : 'smOnly:pt-6',
                    ])}`}
                    data-automation-id="pdp-top-layout"
                >
                    <section
                        className={cx(rowClasses, 'topPromotionalBanner')}
                        data-automation-id="pdp-promotional-banner"
                    >
                        <ErrorBoundary>{renderS1Banner}</ErrorBoundary>
                    </section>
                    <section
                        className={`${cx(rowClasses, 'breadcrumbsRow')} ${dt([
                            'smMd:py-0',
                            'lg:pt-1.5',
                            'lg:pb-2',
                            'sm:!min-h-0',
                        ])} `}
                        data-automation-id="breadcrumb-tite-container"
                    >
                        {displayBreadCrumb()}
                        {recPageType === PLA_REC_PAGE_TYPE ? (
                            <ErrorBoundary>
                                {featureFlags.plaRecommendation ? (
                                    <section className={cx('certona-row')}>
                                        <CertonaZone
                                            page="PDP"
                                            slotDetails={{
                                                pageType: recPageType,
                                                attributes: {
                                                    itemid: ppId,
                                                    recommendations: true,
                                                    pdpDivision,
                                                },
                                                loader: 'certona',
                                                slotId: 'pla1_rr',
                                            }}
                                            isPLAEnabled
                                            schemasToRender={['pla1_rr']}
                                        />
                                    </section>
                                ) : null}
                            </ErrorBoundary>
                        ) : (
                            ''
                        )}
                        {disableOldSkuBelow && isMobileView ? renderTitleSection() : null}
                    </section>

                    {isMobileView &&
                    get(featureFlags, 'enableBopisIncentiveOnTopSec', false) &&
                    disableOldSkuBelow
                        ? displayBopisIncentive()
                        : null}
                    {isMobileView && disableOldSkuBelow
                        ? this.renderPricingStack(
                              ppId,
                              selectedLotPrice,
                              deviceType,
                              isBNPLeligible
                          )
                        : null}

                    {isMobileView && !isOrientationLandscape && !disableOldSkuBelow && (
                        <div
                            className={`${dt(['smOnly:px-0', 'smOnly:pb-2'])} ${cx('bazarVoice')}`}
                        >
                            <ErrorBoundary>
                                <div
                                    className={cx('col10', 'noPad', 'bvSummary-wrapper')}
                                    data-automation-id="bazaar-voice"
                                >
                                    {get(featureFlags, 'bazaarVoice', true) && (
                                        <BVSummary
                                            productDetails={productDetails}
                                            primaryProductDisplay
                                        />
                                    )}
                                </div>
                                {productId ? (
                                    <span
                                        id="productLotNumber"
                                        className={`${cx('productId', 'col2')} ${dt([
                                            'smOnly:pt-px',
                                        ])}`}
                                    >
                                        {productId}
                                    </span>
                                ) : null}
                            </ErrorBoundary>
                        </div>
                    )}
                    <section className={productImageSectionClasses}>
                        <div
                            className={`${cx(
                                'sm12',
                                'md6',
                                'lg7',
                                'xl7',
                                'productImageWrapper'
                            )} ${dt([
                                'smOnly:!w-[calc(100%+48px)]',
                                'smOnly:-mx-6',
                                'smOnly:!p-0',
                                'md:!pl-0',
                                'mdOnly:!pr-2',
                                'lg:!pr-[23px]',
                            ])}`}
                            data-automation-id="image-block"
                        >
                            <ErrorBoundary>
                                <ProductImage
                                    resizeOnScroll={productImageResizeOnScroll}
                                    productDetails={productDetails}
                                    dataAutomationId="product-image-block"
                                    virtualTryOnEnabled={data.enabled}
                                    isMobilePDPImageZoomed={isMobilePDPImageZoomed}
                                    isOrientationLandscapeForZoom={
                                        enableZoomOnProductImage
                                            ? this.state?.isOrientationLandscapeForZoom
                                            : false
                                    }
                                    featureFlags={featureFlags}
                                />
                            </ErrorBoundary>
                            {featureFlags.enablePDPVirtualTryOn ? (
                                <ErrorBoundary>
                                    {templateType === templateTypes.BEAUTY &&
                                    filteredAdvisors?.length === 0 ? (
                                        <VTO />
                                    ) : null}
                                </ErrorBoundary>
                            ) : null}
                        </div>
                        <div
                            className={[
                                cx('lg5', 'xl5', 'productOptionBlock'),
                                dt([
                                    'md:!pr-0',
                                    'md:!pl-2',
                                    'smOnly:!px-0',
                                    !featureFlags.enableVideoPlacementChange && 'smOnly:pt-6',
                                    'mdOnly:pl-2',
                                    'smOnly:w-full',
                                    'mdOnly:w-1/2',
                                    'smMd:inline-block',
                                    'align-top',
                                ]),
                            ].join(' ')}
                            data-automation-id="product-content-block"
                        >
                            <div>
                                {/* For breakpoints other than mobile  */}
                                {(!isMobileView || isOrientationLandscape) && !disableOldSkuBelow && (
                                    <div className={cx('bazarVoice')}>
                                        <ErrorBoundary>
                                            <div
                                                className={cx(
                                                    'col10',
                                                    'noPad',
                                                    'bvSummary-wrapper'
                                                )}
                                                data-automation-id="bazaar-voice"
                                            >
                                                {get(featureFlags, 'bazaarVoice', true) && (
                                                    <BVSummary
                                                        productDetails={productDetails}
                                                        primaryProductDisplay
                                                    />
                                                )}
                                            </div>
                                            {productId ? (
                                                <span
                                                    id="productLotNumber"
                                                    className={cx('productId', 'col2')}
                                                >
                                                    {productId}
                                                </span>
                                            ) : null}
                                        </ErrorBoundary>
                                    </div>
                                )}
                                {!isMobileView && disableOldSkuBelow ? renderTitleSection() : null}
                                {!isMobileView &&
                                disableOldSkuBelow &&
                                get(featureFlags, 'enableBopisIncentiveOnTopSec', false)
                                    ? displayBopisIncentive()
                                    : null}
                                {!isMobileView && disableOldSkuBelow
                                    ? this.renderPricingStack(
                                          ppId,
                                          selectedLotPrice,
                                          deviceType,
                                          isBNPLeligible
                                      )
                                    : null}
                                <ErrorBoundary>
                                    {this.props.virtualTryOn.vtoEligibilityForPP &&
                                    templateType === templateTypes.BEAUTY ? (
                                        <VTOToggle />
                                    ) : null}
                                </ErrorBoundary>

                                <ErrorBoundary>
                                    <ProductOptions
                                        query={query}
                                        productDetails={productDetails}
                                        analytics={analytics}
                                        automationId="product-dimensions-block"
                                    />
                                </ErrorBoundary>
                                {!disableOldSkuBelow && renderTitleSection()}
                                {!disableOldSkuBelow &&
                                get(featureFlags, 'enableBopisIncentiveOnTopSec', false)
                                    ? displayBopisIncentive()
                                    : null}
                                {!disableOldSkuBelow &&
                                    this.renderPricingStack(
                                        ppId,
                                        selectedLotPrice,
                                        deviceType,
                                        isBNPLeligible
                                    )}
                                {displayQSBanner ? (
                                    <div className={dt(['mt-4'])}>
                                        <QuickScreenLazy
                                            bannerType="Mini"
                                            qsBannerCallBack={this.setQSBannerCallbackData}
                                        />
                                    </div>
                                ) : (
                                    isDisplayPLCCBanner && (
                                        <PLCCBanner
                                            PLCCMessage={plccMessage}
                                            emptyDivHeight={emptyPlccDivHeight}
                                        />
                                    )
                                )}
                                {slot4}
                                {slot2}
                                {this.state.errorBannerMessage &&
                                    featureFlags.enableErrorSizing && (
                                        <ProductOptionsErrorBanner
                                            query={query}
                                            errorBannerMessage={this.state.errorBannerMessage}
                                        />
                                    )}
                                <section className={cx('col12', 'selectionContainer')}>
                                    <section
                                        className={[
                                            cx('qtyCartContainer'),
                                            dt(['flex', 'items-center', 'gap-4']),
                                        ].join(' ')}
                                    >
                                        <div
                                            className={[
                                                cx('sm3', 'md3', 'lg2', 'xl2', 'quantity'),
                                                dt(['sm:!w-20']),
                                            ].join(' ')}
                                        >
                                            <ErrorBoundary>
                                                <Quantity
                                                    query={query}
                                                    automationId="product-quantity-block"
                                                    maxQuantity={quantityDropDownValue}
                                                    disabled={quantityDropDownValue === 1}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                        <div
                                            className={[
                                                cx(
                                                    'sm9',
                                                    'md9',
                                                    'lg10',
                                                    'xl10',
                                                    'buttonContainer',
                                                    {
                                                        btnSpacer: isDesktopView,
                                                    }
                                                ),
                                                dt(['smMd:!p-0', 'smMd:!w-full']),
                                            ].join(' ')}
                                        >
                                            <div
                                                className={[
                                                    cx({
                                                        cartBtnSocialWrapper: isDesktopView,
                                                    }),
                                                    dt(['md:flex']),
                                                ].join(' ')}
                                            >
                                                <div
                                                    className={cx(
                                                        { col6: isDesktopView },
                                                        { col8: !isDesktopView },
                                                        'cartBtn'
                                                    )}
                                                >
                                                    <ErrorBoundary>
                                                        <AddToCart
                                                            query={query}
                                                            sticky={featureFlags.stickyAddToCart}
                                                            errorBannerMessage={
                                                                this.state.errorBannerMessage
                                                            }
                                                            updateErrorBannerMessage={(val) => {
                                                                this.setState({
                                                                    errorBannerMessage: val,
                                                                });
                                                            }}
                                                        />
                                                    </ErrorBoundary>
                                                </div>
                                            </div>
                                            <div className={cx('addToCartMessage')}>
                                                <ErrorBoundary>
                                                    <Messages
                                                        messages={this.props.addToCartMessages}
                                                    />
                                                </ErrorBoundary>
                                            </div>
                                        </div>
                                    </section>
                                    {slot1}
                                </section>
                                {!disableBnpl &&
                                    isBNPLeligible &&
                                    getMappedPriceVar &&
                                    bnplProdPriceEligible && (
                                        <div className={cx('BNPLBanner')}>
                                            <BNPLBannerLazy
                                                pageType="PDP"
                                                purchaseAmount={getMappedPriceVar}
                                            />
                                        </div>
                                    )}
                            </div>
                            {get(featureFlags, 'enableStyliticsJumplink', true) && (
                                <div>
                                    <a
                                        id="stylitics-jumplink"
                                        className={dt(['hidden', 'lg:hover:cursor-pointer'])}
                                        onClick={() => {
                                            this.scrollToShopTheLookOnJumplinkClick();
                                        }}
                                    >
                                        <div className={dt(['lg:pt-4', 'smMd:w-full'])}>
                                            {isJumpLinkAvailable && (
                                                <div
                                                    className={dt([
                                                        'flex',
                                                        'justify-center',
                                                        'items-center',
                                                        'gap-8',
                                                        'lg:w-[396px]',
                                                        'h-[99px]',
                                                        'border',
                                                        'border-solid',
                                                        'border-gray-15',
                                                        'rounded-lg',
                                                    ])}
                                                >
                                                    <div
                                                        className={dt(['w-20', 'h-20'])}
                                                        data-automation-id="at-jumplinks-thumbnail-container"
                                                    >
                                                        {isJumpLinkAvailable && (
                                                            <img
                                                                className={dt([
                                                                    'h-full',
                                                                    'w-full',
                                                                    'object-contain',
                                                                ])}
                                                                data-automation-id="at-jumplinks-thumbnail"
                                                                src={
                                                                    (this.state.jumpLinkImage &&
                                                                        this.state.jumpLinkImage[0]
                                                                            ?.dataset?.src) ||
                                                                    (this.state.jumpLinkImage &&
                                                                        this.state.jumpLinkImage[0]
                                                                            ?.src) ||
                                                                    (this.state.isShopTheLook &&
                                                                        this.state.isShopTheLook[0]
                                                                            ?.image_url)
                                                                }
                                                                alt="jumpLinkImage"
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        className={`${cx('jumpLinkText')} ${dt([
                                                            'text-lg',
                                                            'leading-7',
                                                            'font-semibold',
                                                        ])}`}
                                                        data-automation-id="at-jumplinks-text"
                                                    >
                                                        {HOW_TO_STYLE_IT}
                                                    </div>
                                                    <div
                                                        className={dt([
                                                            'w-12',
                                                            'h-12',
                                                            'flex',
                                                            'justify-center',
                                                            'items-center',
                                                            'hover:border',
                                                            'hover:border-solid',
                                                            'hover:border-[#F2F2F2]',
                                                            'hover:bg-[#F2F2F2]',
                                                            'hover:rounded-full',
                                                        ])}
                                                        data-automation-id="at-jumplinks-arrow"
                                                    >
                                                        <Icon
                                                            iconType="svg"
                                                            width="16px"
                                                            height="24px"
                                                            viewBox="0 0 16 24"
                                                            pathClassName={dt(['mr-1'])}
                                                        >
                                                            <IconArrowRight />
                                                        </Icon>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </a>
                                </div>
                            )}
                            {enableRevieveModulePDP && filteredAdvisors?.length > 0 && (
                                <ErrorBoundary>
                                    <div
                                        className={dt(['pt-4', 'h-[103px]'])}
                                        data-automation-id="at-revieveModule-container"
                                    >
                                        <div className={dt(['lg:w-[396px]'])}>
                                            <RevieveModal
                                                data={filteredAdvisors[0]?.analyticsId}
                                                isCoremedia={false}
                                                componentToBeRendered={revieveModulePDP()}
                                            />
                                        </div>
                                    </div>
                                </ErrorBoundary>
                            )}
                        </div>
                    </section>
                    <BelowTheFold>
                        <KeyFeatures featureAttributes={valuesList} />
                        <ErrorBoundary>
                            <div className={dt(['pb-6', 'flex', 'flex-col'])}>
                                <DescriptionAndShipping />
                            </div>
                        </ErrorBoundary>
                        {enableBVUserGeneratedContent && <BVUserGeneratedContent ppId={ppId} />}
                        {isCollection && query ? (
                            <ErrorBoundary>
                                {get(featureFlags, 'productCollection', true) ? (
                                    <ProductCollection
                                        productDetails={productDetails}
                                        enrId={query.enrId}
                                        automationId="product-collection"
                                        location={this.props.location}
                                        removeLinkPrefix={featureFlags.removeLinkPrefix}
                                    />
                                ) : null}
                            </ErrorBoundary>
                        ) : null}
                        <ErrorBoundary>
                            {isShopTheSetEligible &&
                            get(featureFlags, 'enableShopTheSet', true) &&
                            !detectisIE() ? (
                                <ShopTheSet
                                    productDetails={productDetails}
                                    outfitsData={this.outfitsData}
                                    jumpLink={this.jumpLinkImage}
                                />
                            ) : null}
                        </ErrorBoundary>
                        <ErrorBoundary>
                            {!isEmpty(homeDivision) &&
                            !mixAndMatchDivisions.includes(homeDivision) &&
                            !isMTMOrVdata &&
                            get(featureFlags, 'enableShopTheLook', true) &&
                            !detectisIE() ? (
                                <ShopTheLook
                                    productDetails={productDetails}
                                    outfitsData={this.outfitsData}
                                    jumpLink={this.jumpLinkImage}
                                />
                            ) : null}
                        </ErrorBoundary>
                        {deviceType.isDesktop &&
                            get(featureFlags, 'enableMixAndMatch', true) &&
                            mixAndMatchBlock()}
                        {!deviceType.isDesktop &&
                            get(featureFlags, 'enableMixAndMatchMobile', true) &&
                            mixAndMatchBlock()}
                        {templateType !== templateTypes.BUNDLE && (
                            <section
                                className={`${cx('lg8', 'xl8', 'md10', 'sm12')} ${dt([
                                    'sm:!block',
                                    'mx-auto',
                                    'text-center',
                                    'lg:!px-1',
                                    'smMd:!px-0',
                                ])}`}
                            >
                                <MerchantMarketing
                                    productDetails={productDetails}
                                    automationId="merchant-marketing-block"
                                />
                            </section>
                        )}
                        {isDesktopView ? (
                            <section
                                className={`${cx('section')} ${dt(['sm:!my-0'])}`}
                                data-automation-id="desktop-product-compare"
                            >
                                <div
                                    className={`${cx(
                                        'small12',
                                        'medium12',
                                        'large12',
                                        'extraLarge12',
                                        rowClasses
                                    )} ${dt(['sm:pt-0'])}`}
                                >
                                    <ErrorBoundary>
                                        <ProductInfoDesktop
                                            dataAutomationId="product-info"
                                            productDetails={productDetails}
                                            pageType={recPageType}
                                            pTmplType={query.pTmplType}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </section>
                        ) : (
                            <section
                                className={`${cx('section')} ${dt(['sm:!my-0'])}`}
                                data-automation-id="mobile-product-compare"
                            >
                                <div
                                    className={`${cx(
                                        'small12',
                                        'medium12',
                                        'large12',
                                        'extraLarge12',
                                        rowClasses
                                    )} ${dt(['sm:pt-0'])}`}
                                >
                                    <ErrorBoundary>
                                        <ProductInfoMobile
                                            dataAutomationId="product-info"
                                            productDetails={productDetails}
                                            pageType={recPageType}
                                            featureFlags={featureFlags}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </section>
                        )}
                        <ErrorBoundary>
                            {featureFlags.productCartridgeZone4 ? (
                                <section
                                    className={cx('certona-row')}
                                    data-automation-id="pdp-reczones-block"
                                >
                                    <CertonaZone
                                        page="PDP"
                                        slotDetails={{
                                            pageType: recPageType,
                                            attributes: {
                                                itemid: ppId,
                                                recommendations: true,
                                                pdpDivision,
                                            },
                                            loader: 'certona',
                                            automationId: 'pdp-reczones',
                                            slotId: 'product4_rr',
                                        }}
                                        schemasToRender={['product4_rr']}
                                        bottomPadding={dt(['mb-10'])}
                                    />
                                </section>
                            ) : null}
                        </ErrorBoundary>
                        {/* For Ensighten team to inject display ads section. */}
                        {!displayAds ? null : (
                            <StaticContainer>
                                {!isNative && (
                                    <div
                                        className={`${cx('bv-ad-wrapper', rowClasses)} ${dt([
                                            '!pt-2',
                                            '!pb-2',
                                        ])}`}
                                    >
                                        {enableFreestarAdComponent && isTrackingCookieActive && (
                                            <>
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-1"
                                                    className={freestarAdClasses}
                                                />
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-2"
                                                    className={freestarAdClasses}
                                                />
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-3"
                                                    className={freestarAdClasses}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                            </StaticContainer>
                        )}
                    </BelowTheFold>
                </section>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    preferences: selectPreferences(state),
    productDetails: state.productDetails,
    deviceType: state.context ? state.context.deviceType : {},
    analytics: state.Analytics,
    inventory: state.inventory,
    addToCartMessages: state.messages?.[ADD_TO_CART_MESSAGES_ID],
    selectedProductLot: selectedProductSkus(false)(state),
    selectedLotPrice: productLotSelector(false)(state),
    pdpProductType: selectProductType(ownProps.fromMiniPDP)(state),
    bopisIncentiveProductEligibility: bopisIncentiveProductEligibilitySelector(
        ownProps.fromMiniPDP
    )(state),
    isNative: state.context ? state.context.isNative : {},
    virtualTryOn: getVirtualTryOnData(state),
    recPageType: selectRecPageType(state),
    quantityDropDownValue: getMOQDropdownValue(false)(state),
    isQuickScreenEligible: state?.signInSliderDetails?.isQuickScreenEligible,
    pricingDetails: productPricingSelector(ownProps.fromMiniPDP)(state),
    isMobilePDPImageZoomed: selectIsMobilePDPImageZoomed(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getCriteoData,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(Regular));
